/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { ReactComponent as ChevronLeft } from '@assets/svg/icons/logbook/ChevronLeft.svg';
import { ReactComponent as ChevronRight } from '@assets/svg/icons/logbook/ChevronRight.svg';
import { useLogbookContext } from '@context';
import './index.scss';

const { Option } = Select;

type ArrowProps = {
  type: 'prev' | 'next';
  onClick: () => void;
  disabled?: boolean;
  style?: { borderRadius?: number };
};

export const ArrowBlock: React.FC<ArrowProps> = ({
  type,
  onClick,
  disabled,
  style,
}: ArrowProps) => (
  <div
    style={style}
    onClick={onClick}
    className={`pagination-block ${disabled ? 'pagination-block-disabled' : ''} ${
      type === 'prev' ? 'pagination-block-prev' : 'pagination-block-next'
    }`}
  >
    {type === 'prev' ? <ChevronLeft fill="white" /> : <ChevronRight fill="white" />}
  </div>
);
type PageProps = {
  page: number;
  isSelected: boolean;
  onClick?: (page: number) => void;
};

const PageBlock: React.FC<PageProps> = ({ page, isSelected, onClick }: PageProps) => {
  const handleClick = () => {
    onClick?.(page);
  };

  return (
    <div
      onClick={handleClick}
      className={`pagination-block ${isSelected ? 'pagination-block-active' : ''}`}
    >
      {page}
    </div>
  );
};

type PaginationProps = {
  selectedPage?: number;
  onChangePage?: (page: number) => void;
  total?: number;
  isLoading?: boolean;
  perPage: PerPageType;
  onPerPageChange?: (perPage: PerPageType) => void;
};

export type PerPageType = 5 | 10 | 15;

const perPageOptions = [5, 10, 15];

const Pagination: React.FC<PaginationProps> = (props: PaginationProps) => {
  const { selectedPage = 1, onChangePage, total = 0, perPage, onPerPageChange, isLoading } = props;
  const totalShown = selectedPage * perPage;
  const { tableState, tableDispatch } = useLogbookContext();
  const {
    paginationLimits: { right, left },
  } = tableState;
  const [pages, setPages] = useState(0);

  const updateLimits = (left: number, right: number) =>
    tableDispatch({ type: 'paginationLimits', payload: { right, left } });

  const [pagesArray, setPagesArray] = useState<number[]>([]);

  useEffect(() => {
    if (!isLoading) {
      setPages(Math.ceil(total / perPage));
      setPagesArray(new Array(pages).fill(0));
    }
  }, [isLoading, pages, total, perPage]);

  useEffect(() => {
    if (selectedPage > right) {
      updateLimits(
        right + 1 === pages ? selectedPage - 9 : selectedPage - 1,
        right + 1 === pages ? selectedPage + 1 : selectedPage + 9,
      );
    }
    if (selectedPage <= left) {
      updateLimits(
        selectedPage - 10 <= 0 ? 0 : selectedPage - 10,
        selectedPage === 1 && total > 1 ? selectedPage + 8 : selectedPage,
      );
    }
  }, [selectedPage, right, left]);

  const shiftPage = (value: number) => onChangePage && onChangePage(value);

  const handleNext = () => {
    if (pages > selectedPage) {
      shiftPage(selectedPage + 1);
    }
  };

  const handlePrev = () => {
    if (selectedPage !== 1) {
      shiftPage(selectedPage - 1);
    }
  };

  const handlePageSelection = (value: number) => shiftPage(value);

  const handlePerPageSelection = (value: PerPageType) => onPerPageChange && onPerPageChange(value);
  if ((pages === 1 && perPage === 5) || pages === 0) {
    return <></>;
  }
  return (
    <div className="pagination-container">
      <div className="pagination-item">
        <p className="pagination-text">Jump to page:</p>
        <Select
          value={selectedPage}
          onChange={handlePageSelection}
          defaultValue={selectedPage}
          style={{ width: 83 }}
        >
          {pagesArray.map((_, index) => (
            <Option key={index} value={index + 1}>
              {index + 1}
            </Option>
          ))}
        </Select>
      </div>
      <div className="pages">
        <ArrowBlock type="prev" onClick={handlePrev} disabled={selectedPage === 1} />
        {pagesArray
          .map((_, index) => (
            <PageBlock
              onClick={onChangePage}
              isSelected={selectedPage === index + 1}
              key={index}
              page={index + 1}
            />
          ))
          .slice(left, right)}
        <ArrowBlock type="next" onClick={handleNext} disabled={selectedPage === pages} />
      </div>
      <div className="pagination-item">
        <p className="pagination-text">Show:</p>
        <Select
          value={perPage}
          onChange={handlePerPageSelection}
          defaultValue={perPage}
          style={{ width: 83 }}
        >
          {perPageOptions.map((i) => (
            <Option key={i} value={i}>
              {i}
            </Option>
          ))}
        </Select>
      </div>
      <p className="pagination-total">
        <b>{totalShown > total ? totalShown - (totalShown - total) : totalShown}</b> of {total}
      </p>
    </div>
  );
};

export default Pagination;
